
const PausePlayAnimation = (entries, ...ids) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            ids.forEach(id => {
               let elem = document.getElementById(id)
               if(elem !== null){
                elem.play();
               }
            });
        } else {
            ids.forEach(id => {
                let elem = document.getElementById(id)
                if(elem !== null){
                    elem.pause();
                }
             });
        }
    });
}

// Swiper Autoplay Pause when swiper is not in viewport 

const PauseSwiperAutoPlay = (swiper) => {
    const observer = new IntersectionObserver(
        ([entry]) => {
            if (entry.isIntersecting) {
                if (swiper.autoplay && swiper.autoplay.start) {
                    swiper.autoplay.start();
                }
            } else {
                if (swiper.autoplay && swiper.autoplay.stop) {
                    swiper.autoplay.stop();
                }
            }
        },
        { threshold: 0 }
    );
    observer.observe(swiper.el);
}


export { PausePlayAnimation, PauseSwiperAutoPlay }